<div class="encabezado">
  <div class="col-4 getBack">
    <a routerLink="/settings" class="getBack">
      <span
        ><i class="icon-chevron-left"></i>{{ "forms.buttons.back" | translate }}
      </span></a
    >
  </div>
  <div class="">
    <div class="">
      <div>
        <h5 class="titulo1">
          {{ "titles-menu-pages.automations" | translate }}
        </h5>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-8">
      <app-shared-filter
        (filterChanged)="filterChanged($event)"
        [type]="'automation'"
      ></app-shared-filter>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="btn-izq">
        <button class="btn btn-hover" type="button" (click)="toggleForm()">
          {{ "buttons.add+" | translate }} <i class="icon-plus"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="tabla">
    <div class="table-responsive-wrapper">
    <div class="table-scroll-inner">
    <table
      mat-table
      class="full-width-table"
      matSort
      aria-label="Brands"
      [dataSource]="dataSource"
    >
      <!-- name Column -->
      <ng-container matColumnDef="name">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="cabecera-tabla"
        >
          {{ "inputs.rule_name" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
      </ng-container>
      <!-- description Column -->
      <ng-container matColumnDef="description">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="cabecera-tabla"
        >
          {{ "inputs.rule_descr" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">{{ row.description }}</td>
      </ng-container>
      <!-- entity Column -->
      <ng-container matColumnDef="entity">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="cabecera-tabla"
        >
          {{ "inputs.entity" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          <span *ngIf="row.entity === 'orders'" class="badge bg-primary">
            {{ "inputs.orders" | translate }}
          </span>
          <span *ngIf="row.entity === 'campaigns'" class="badge bg-success">
            {{ "inputs.campaigns" | translate }}
          </span>
        </td>
      </ng-container>
      <!-- events Column -->
      <ng-container matColumnDef="events">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="cabecera-tabla"
        >
          {{ "inputs.event" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          {{ "automation.event." + row.events | translate }}
        </td>
      </ng-container>
      <!-- conditions Column -->
      <ng-container matColumnDef="conditions">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="cabecera-tabla"
        >
          {{ "inputs.condition" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="column-list">
            <span *ngFor="let condition of row.conditions"
              >{{ "automation.conditions." + condition.condition | translate }}:
              {{ condition.value }}</span
            >
          </div>
        </td>
      </ng-container>
      <!-- actions Column -->
      <ng-container matColumnDef="actions">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="cabecera-tabla"
        >
          {{ "inputs.action" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="column-list">
            <!--  <span> {{ row.actions }}</span> -->
            <span *ngFor="let action of row.actions"
              >{{ "automation.actions." + action.action | translate }}:
              {{ action.value }}</span
            >
          </div>
        </td>
      </ng-container>
      <!-- enabled Column -->
      <ng-container matColumnDef="enabled">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="cabecera-tabla"
        >
          {{ "inputs.enabled" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          <span *ngIf="row.enabled" class="badge bg-info">{{
            "inputs.enabled" | translate
          }}</span
          ><span *ngIf="!row.enabled" class="badge bg-warning">{{
            "inputs.disabled" | translate
          }}</span>
        </td>
      </ng-container>
      <!-- rowActions Column -->
      <ng-container matColumnDef="rowActions">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="cabecera-tabla"
        >
          {{ "inputs.actions" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          <i
            class="icon-pencil text-success icon-actions"
            (click)="getAutomation(row.reference)"
          ></i>
          <i
            class="icon-trash2 text-danger icon-actions"
            (click)="deleteAutomation(row.reference)"
          ></i>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    </div>
    </div>
    <!-- Card layout mobile -->
    <div class="cards-mobile-wrapper">
      <div *ngFor="let row of dataSource.data" class="settings-card" (click)="getAutomation($any(row).reference)">
        <div class="card-header-row">
          <span class="card-name">{{ $any(row).name }}</span>
          <span *ngIf="$any(row).enabled" class="badge bg-info">{{ "inputs.enabled" | translate }}</span>
          <span *ngIf="!$any(row).enabled" class="badge bg-warning">{{ "inputs.disabled" | translate }}</span>
        </div>
        <div class="card-body-content">
          <span *ngIf="$any(row).description" class="card-detail">{{ $any(row).description }}</span>
          <span class="card-detail">
            <span *ngIf="$any(row).entity === 'orders'" class="badge bg-primary">{{ "inputs.orders" | translate }}</span>
            <span *ngIf="$any(row).entity === 'campaigns'" class="badge bg-success">{{ "inputs.campaigns" | translate }}</span>
            &nbsp;{{ "automation.event." + $any(row).events | translate }}
          </span>
        </div>
        <div class="card-footer-row">
          <div class="card-actions">
            <i class="icon-pencil text-success icon-actions" (click)="getAutomation($any(row).reference); $event.stopPropagation()"></i>
            <i class="icon-trash2 text-danger icon-actions" (click)="deleteAutomation($any(row).reference); $event.stopPropagation()"></i>
          </div>
        </div>
      </div>
    </div>
    <mat-paginator
      [length]="paginator.length ? paginator.length : 25"
      [pageSize]="paginator.pageSize"
      [pageSizeOptions]="paginator.pageSizeOptions"
      (page)="onPageChange($event)"
    >
    </mat-paginator>
  </div>
</div>
<div
  class="formulario-derecha-container"
  [ngClass]="{ 'mostrar-formulario': showForm }"
>
  <app-form-add-automation
    [automationData]="automationData"
    (backButtonClick)="cerrarFormulario()"
    (addAutomation)="refrescar()"
  ></app-form-add-automation>
</div>
<div class="overlay" *ngIf="showForm"></div>
